var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ds-modal',{attrs:{"show-close":"","is-open":"","title":_vm.$t('unlayerBuilder.saveAsTemplate.modal.title')},on:{"close":function($event){return _vm.$emit('close')}}},[_c('save-as-template-form',{attrs:{"editor":_vm.editor,"funnel-id":_vm.funnelId,"template-id":_vm.templateId},on:{"saved":function($event){return _vm.$emit('close')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }